module.exports = __webpack_public_path__ + "img/Niktmi_sie_nie_oprze.d563f43b.jpg";